import { render, staticRenderFns } from "./TheDrawer.vue?vue&type=template&id=4ca53fef&"
import script from "./TheDrawer.vue?vue&type=script&lang=js&"
export * from "./TheDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TheDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports